import Raphael from './raphael.min'
import RedMarker from 'assets/img/red-marker.svg'
import BlackMarker from 'assets/icons/marker-black.svg'
import Eraser from 'assets/img/eraser.svg'

var g_masterPathArray1
var g_masterDrawingBox1
var masterBackground1
var g_masterPaper1
var st1
var fun_setIsScreenMarked1

var g_masterPathArray2
var g_masterDrawingBox2
var masterBackground2
var g_masterPaper2
var st2
var fun_setIsScreenMarked2

var g_masterPathArrayNotes
var g_masterDrawingBoxNotes
var masterBackgroundNotes
var g_masterPaperNotes
var stNotes
var fun_setIsScreenMarkedNotes

const RED_MARKER_STYLE = { stroke: '#EC7063', 'stroke-width': 3 }
const BLACK_MARKER_STYLE = { stroke: '#323233', 'stroke-width': 3 }
let activeMarkerStyle = RED_MARKER_STYLE

var start1 = function () {
    g_masterPathArray1 = []
  },
  move1 = function () {
    console.log('cords', this.ox, this.oy + 12)
    if (g_masterPathArray1.length === 0) {
      g_masterPathArray1[0] = ['M', this.ox, this.oy]
      g_masterDrawingBox1 = g_masterPaper1.path(g_masterPathArray1)
      g_masterDrawingBox1.attr(activeMarkerStyle)
    } else
      g_masterPathArray1[g_masterPathArray1.length] = ['L', this.ox, this.oy]

    g_masterDrawingBox1.attr({ path: g_masterPathArray1 })
  },
  up1 = function () {
    st1.push(g_masterDrawingBox1)
  }

var start2 = function () {
    g_masterPathArray2 = []
  },
  move2 = function () {
    if (g_masterPathArray2.length === 0) {
      g_masterPathArray2[0] = ['M', this.ox, this.oy]
      g_masterDrawingBox2 = g_masterPaper2.path(g_masterPathArray2)
      g_masterDrawingBox2.attr(activeMarkerStyle)
    } else
      g_masterPathArray2[g_masterPathArray2.length] = ['L', this.ox, this.oy]

    g_masterDrawingBox2.attr({ path: g_masterPathArray2 })
  },
  up2 = function () {
    st2.push(g_masterDrawingBox2)
    console.log('g_masterPathArray', g_masterPathArray2)
  }

var startNotes = function () {
    g_masterPathArrayNotes = []
  },
  moveNotes = function () {
    if (g_masterPathArrayNotes.length === 0) {
      g_masterPathArrayNotes[0] = ['M', this.ox, this.oy]
      g_masterDrawingBoxNotes = g_masterPaperNotes.path(g_masterPathArrayNotes)
      g_masterDrawingBoxNotes.attr(activeMarkerStyle)
    } else {
      g_masterPathArrayNotes[g_masterPathArrayNotes.length] = [
        'L',
        this.ox,
        this.oy
      ]
    }

    g_masterDrawingBoxNotes.attr({ path: g_masterPathArrayNotes })
  },
  upNotes = function () {
    stNotes.push(g_masterDrawingBoxNotes)
  }

export function initDrawing(width, height) {
  const container = document.getElementById('sketchContainerELA')
  if (container) {
    container.style.position = 'relative'
    g_masterPaper1 = Raphael(container, width, height)
    g_masterPaper1.canvas.style['position'] = 'absolute'
    g_masterPaper1.canvas.style['left'] = '0'
    g_masterPaper1.canvas.style['top'] = '0'
    g_masterPaper1.canvas.style['pointer-events'] = 'none'
    masterBackground1 = g_masterPaper1.rect(0, 0, width, height)
    masterBackground1.attr({ stroke: 0, fill: '#eee', 'fill-opacity': 0 })
    st1 = g_masterPaper1.set()
    return g_masterPaper1
  }
}

export function initDrawingQuestions(width, height) {
  const container = document.getElementById('sketchContainerQuestions')
  if (container) {
    g_masterPaper2 = Raphael(container, width, height)
    g_masterPaper2.canvas.style['position'] = 'absolute'
    g_masterPaper2.canvas.style['pointer-events'] = 'none'
    masterBackground2 = g_masterPaper2.rect(0, 0, width, height)
    masterBackground2.attr({ stroke: 0, fill: '#eee', 'fill-opacity': 0 })
    st2 = g_masterPaper2.set()
    return g_masterPaper2
  }
}

export function initDrawingNotes(width, height) {
  const container = document.getElementById('sketchContainerNotes')
  if (container) {
    g_masterPaperNotes = Raphael(container, width, height)
    g_masterPaperNotes.canvas.style['position'] = 'absolute'
    g_masterPaperNotes.canvas.style['pointer-events'] = 'none'
    masterBackgroundNotes = g_masterPaperNotes.rect(0, 0, width, height)
    masterBackgroundNotes.attr({ stroke: 0, fill: '#eee', 'fill-opacity': 0 })
    stNotes = g_masterPaperNotes.set()
    return g_masterPaperNotes
  }
}

export const updatePaperSize = (width, height) => {
  if (!g_masterPaper1 || !masterBackground1) return

  g_masterPaper1.setSize(width, height)
  masterBackground1.attr('width', width)
  masterBackground1.attr('height', height)
}

export function bindMouseEvnt(event) {
  //   var evt = event;
  //   var IE = document.all ? true : false;
  //   var x, y;
  //   if (IE) {
  //     x =
  //       evt.clientX +
  //       document.body.scrollLeft +
  //       document.documentElement.scrollLeft;
  //     y =
  //       evt.clientY +
  //       document.body.scrollTop +
  //       document.documentElement.scrollTop;
  //   } else {
  //     x = evt.pageX;
  //     y = evt.clientY;
  //   }

  // subtract paper coords on page
  this.ox =
    event.clientX +
    event.target.scrollLeft -
    event.target.getBoundingClientRect().left -
    15
  this.oy =
    event.clientY +
    event.target.scrollTop -
    event.target.getBoundingClientRect().top
}

export function bindDrawing(setIsScreenMarked, options = {}) {
  const { markerColor } = options

  const MarkerIcon = markerColor === 'black' ? BlackMarker : RedMarker
  activeMarkerStyle =
    markerColor === 'black' ? BLACK_MARKER_STYLE : RED_MARKER_STYLE

  if (g_masterPaper1) {
    unbindEraser()
    g_masterPaper1.canvas.id = 'sketch-container'
    g_masterPaper1.canvas.style['pointer-events'] = 'auto'
    g_masterPaper1.canvas.style['cursor'] = `url(${MarkerIcon}) 14 41, move`
    g_masterPaper1.canvas.style['z-index'] = 99
    g_masterPaper1.canvas.style['top'] = 0
    masterBackground1.drag(move1, start1, up1)
    masterBackground1.mousemove(bindMouseEvnt)
    fun_setIsScreenMarked1 = (event) => {
      setIsScreenMarked(true)
    }
    masterBackground1.mouseup(fun_setIsScreenMarked1)
  }
}

export function bindDrawingQuestions(setIsScreenMarked) {
  activeMarkerStyle = RED_MARKER_STYLE
  console.log('bind called questions', g_masterPaper2)
  if (g_masterPaper2) {
    unbindEraserQuestions()
    g_masterPaper2.canvas.id = 'sketch-container-questions'
    g_masterPaper2.canvas.style['pointer-events'] = 'auto'
    g_masterPaper2.canvas.style['cursor'] = `url(${RedMarker}) 14 41, move`
    g_masterPaper2.canvas.style['z-index'] = 99
    g_masterPaper2.canvas.style['top'] = 0
    masterBackground2.drag(move2, start2, up2)
    masterBackground2.mousemove(bindMouseEvnt)
    fun_setIsScreenMarked2 = (event) => {
      setIsScreenMarked(true)
    }
    masterBackground2.mouseup(fun_setIsScreenMarked2)
  }
}

export function bindDrawingNotes(setIsScreenMarked, options = {}) {
  const { markerColor } = options

  const MarkerIcon = markerColor === 'black' ? BlackMarker : RedMarker
  activeMarkerStyle =
    markerColor === 'black' ? BLACK_MARKER_STYLE : RED_MARKER_STYLE

  if (g_masterPaperNotes) {
    unbindEraserNotes()
    g_masterPaperNotes.canvas.id = 'sketch-container-notes'
    g_masterPaperNotes.canvas.style['pointer-events'] = 'auto'
    g_masterPaperNotes.canvas.style['cursor'] = `url(${MarkerIcon}) 14 41, move`
    g_masterPaperNotes.canvas.style['z-index'] = 99
    g_masterPaperNotes.canvas.style['top'] = 0
    masterBackgroundNotes.drag(moveNotes, startNotes, upNotes)
    masterBackgroundNotes.mousemove(bindMouseEvnt)
    fun_setIsScreenMarkedNotes = (event) => {
      setIsScreenMarked(true)
    }
    masterBackgroundNotes.mouseup(fun_setIsScreenMarkedNotes)
  }
}

export function unbindDrawing() {
  if (g_masterPaper1) {
    g_masterPaper1.canvas.style['pointer-events'] = 'none'
    // g_masterPaper.canvas.style['cursor'] = 'default'
    masterBackground1.unmouseup(fun_setIsScreenMarked1)
    masterBackground1.unmousemove(bindMouseEvnt)
    masterBackground1.drag(move1, start1, up1)
  }
}

export function unbindDrawingQuestions() {
  if (g_masterPaper2) {
    g_masterPaper2.canvas.style['pointer-events'] = 'none'
    // g_masterPaper.canvas.style['cursor'] = 'default'
    masterBackground2.unmouseup(fun_setIsScreenMarked2)
    masterBackground2.unmousemove(bindMouseEvnt)
    masterBackground2.drag(move2, start2, up2)
  }
}

export function unbindDrawingNotes() {
  if (g_masterPaperNotes) {
    g_masterPaperNotes.canvas.style['pointer-events'] = 'none'
    masterBackgroundNotes.unmouseup(fun_setIsScreenMarkedNotes)
    masterBackgroundNotes.unmousemove(bindMouseEvnt)
    masterBackgroundNotes.drag(moveNotes, startNotes, upNotes)
  }
}

export function eraseDrawing() {
  if (st1) {
    st1.forEach(function (el) {
      el?.remove()
    })

    st1.clear()
  }

  if (st2) {
    st2.forEach(function (el) {
      el?.remove()
    })
    st2.clear()
  }
}

export function eraseDrawingNotes() {
  if (stNotes) {
    stNotes.forEach(function (el) {
      el?.remove()
    })
    stNotes.clear()
  }
}

export const setMarkings = (penMarkings, penMarkingsQuestions) => {
  if (!penMarkings && !penMarkingsQuestions) return

  eraseDrawing()

  penMarkings?.forEach(function (paths) {
    g_masterDrawingBox1 = g_masterPaper1.path(paths).attr(activeMarkerStyle)
    st1.push(g_masterDrawingBox1)
  })

  penMarkingsQuestions?.forEach(function (paths) {
    g_masterDrawingBox2 = g_masterPaper2.path(paths).attr(activeMarkerStyle)
    st2.push(g_masterDrawingBox2)
  })
}

export const getMarkings = () => {
  const penMarkings = []

  st1?.forEach(function (el) {
    el?.attrs?.path && penMarkings.push(el.attrs.path)
  })

  return penMarkings
}

export const getMarkingsQuestions = () => {
  const penMarkings = []

  st2?.forEach(function (el) {
    el?.attrs?.path && penMarkings.push(el.attrs.path)
  })

  return penMarkings
}

export const getMarkingsNotes = () => {
  const penMarkings = []

  stNotes?.forEach(function (el) {
    if (el?.attrs?.path) {
      penMarkings.push({
        path: el.attrs.path,
        stroke: el.attrs.stroke || RED_MARKER_STYLE.stroke,
        strokeWidth:
          el.attrs['stroke-width'] || RED_MARKER_STYLE['stroke-width']
      })
    }
  })

  return penMarkings
}

export const setMarkingsNotes = (penMarkingsNotes) => {
  if (!g_masterPaperNotes || !Array.isArray(penMarkingsNotes)) {
    return
  }

  eraseDrawingNotes()

  penMarkingsNotes.forEach(function (marking) {
    if (!marking?.path) return

    g_masterDrawingBoxNotes = g_masterPaperNotes.path(marking.path).attr({
      stroke: marking.stroke || RED_MARKER_STYLE.stroke,
      'stroke-width': marking.strokeWidth || RED_MARKER_STYLE['stroke-width']
    })

    stNotes.push(g_masterDrawingBoxNotes)
  })
}

export const bindEraser = (setIsScreenMarked) => {
  if (masterBackground1 && g_masterPaper1) {
    unbindDrawing()
    masterBackground1.undrag()
    g_masterPaper1.canvas.style['pointer-events'] = 'auto'
    g_masterPaper1.canvas.style['cursor'] = `url(${Eraser}) 14 41, move`
    g_masterPaper1.canvas.style['z-index'] = 99
    g_masterPaper1.canvas.style['top'] = 0
    // g_masterPaper.canvas.style['cursor'] = 'default';
    masterBackground1.mousemove(bindMouseEvnt)
    function start() {}

    function up() {}
    masterBackground1.drag(eraseMarkings, start, up)
  }
}

export const bindEraserQuestions = (setIsScreenMarked) => {
  unbindDrawingQuestions()
  masterBackground2.undrag()
  g_masterPaper2.canvas.style['pointer-events'] = 'auto'
  g_masterPaper2.canvas.style['cursor'] = `url(${Eraser}) 14 41, move`
  g_masterPaper2.canvas.style['z-index'] = 99
  g_masterPaper2.canvas.style['top'] = 0
  // g_masterPaper.canvas.style['cursor'] = 'default';
  masterBackground2.mousemove(bindMouseEvnt)
  function start() {}

  function up() {}
  masterBackground2.drag(eraseMarkingsQuestions, start, up)
}

export const bindEraserNotes = () => {
  if (masterBackgroundNotes && g_masterPaperNotes) {
    unbindDrawingNotes()
    masterBackgroundNotes.undrag()
    g_masterPaperNotes.canvas.style['pointer-events'] = 'auto'
    g_masterPaperNotes.canvas.style['cursor'] = `url(${Eraser}) 14 41, move`
    g_masterPaperNotes.canvas.style['z-index'] = 99
    g_masterPaperNotes.canvas.style['top'] = 0
    masterBackgroundNotes.mousemove(bindMouseEvnt)
    function start() {}

    function up() {}
    masterBackgroundNotes.drag(eraseMarkingsNotes, start, up)
  }
}

export function unbindEraser() {
  if (g_masterPaper1) {
    g_masterPaper1.canvas.style['pointer-events'] = 'none'
    g_masterPaper1.canvas.style['cursor'] = 'default'
    masterBackground1.unmousemove(bindMouseEvnt)
    masterBackground1.undrag()
  }
}

export function unbindEraserQuestions() {
  if (g_masterPaper2) {
    g_masterPaper2.canvas.style['pointer-events'] = 'none'
    g_masterPaper2.canvas.style['cursor'] = 'default'
    masterBackground2.unmousemove(bindMouseEvnt)
    masterBackground2.undrag()
  }
}

export function unbindEraserNotes() {
  if (g_masterPaperNotes) {
    g_masterPaperNotes.canvas.style['pointer-events'] = 'none'
    g_masterPaperNotes.canvas.style['cursor'] = 'default'
    masterBackgroundNotes.unmousemove(bindMouseEvnt)
    masterBackgroundNotes.undrag()
  }
}

let prevPoint = null
export function eraseMarkings() {
  if (!prevPoint) {
    prevPoint = { x: this.ox, y: this.oy + 12 }
    return
  }

  const x = this.ox,
    y = this.oy + 12

  st1?.forEach(function (el) {
    let isDelete = false
    const filteredPath = el.attrs?.path?.map((item, index) => {
      if (index === 0) {
        return item
      }

      const prevItem = el.attrs.path[index - 1]

      const intersection = findIntersection(
        prevPoint.x,
        prevPoint.y,
        x,
        y,
        prevItem[1],
        prevItem[2],
        item[1],
        item[2]
      )
      if (!intersection) {
        return item
      }

      isDelete = true
      item[0] = 'M'
      prevItem[0] = 'M'

      return item
    })
    filteredPath?.length && el.attr({ path: filteredPath })
    // const isModified = filteredPath?.every(item => item[0] === 'M');
    if (isDelete) {
      // setIsScreenMarked(true);
      el.remove()
    }
  })

  prevPoint = { x, y }
}

let prevPoint2 = null
export function eraseMarkingsQuestions() {
  if (!prevPoint2) {
    prevPoint2 = { x: this.ox, y: this.oy + 12 }
    return
  }

  const x = this.ox,
    y = this.oy + 12

  st2?.forEach(function (el) {
    let isDelete = false
    const filteredPath = el.attrs?.path?.map((item, index) => {
      if (index === 0) {
        return item
      }

      const prevItem = el.attrs.path[index - 1]

      const intersection = findIntersection(
        prevPoint2.x,
        prevPoint2.y,
        x,
        y,
        prevItem[1],
        prevItem[2],
        item[1],
        item[2]
      )
      if (!intersection) {
        return item
      }

      isDelete = true
      item[0] = 'M'
      prevItem[0] = 'M'

      return item
    })
    filteredPath?.length && el.attr({ path: filteredPath })
    // const isModified = filteredPath?.every(item => item[0] === 'M');
    if (isDelete) {
      // setIsScreenMarked(true);
      el.remove()
    }
  })

  prevPoint2 = { x, y }
}

let prevPointNotes = null
export function eraseMarkingsNotes() {
  if (!prevPointNotes) {
    prevPointNotes = { x: this.ox, y: this.oy + 12 }
    return
  }

  const x = this.ox,
    y = this.oy + 12

  stNotes?.forEach(function (el) {
    let isDelete = false
    const filteredPath = el.attrs?.path?.map((item, index) => {
      if (index === 0) {
        return item
      }

      const prevItem = el.attrs.path[index - 1]

      const intersection = findIntersection(
        prevPointNotes.x,
        prevPointNotes.y,
        x,
        y,
        prevItem[1],
        prevItem[2],
        item[1],
        item[2]
      )
      if (!intersection) {
        return item
      }

      isDelete = true
      item[0] = 'M'
      prevItem[0] = 'M'

      return item
    })
    filteredPath?.length && el.attr({ path: filteredPath })
    if (isDelete) {
      el.remove()
    }
  })

  prevPointNotes = { x, y }
}

function findIntersection(x1, y1, x2, y2, x3, y3, x4, y4) {
  let denominator = null
  // Check if none of the lines are of length 0
  if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
    return false
  }

  denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1)

  // Lines are parallel
  if (denominator === 0) {
    return false
  }

  let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator
  let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator

  // is the intersection along the segments
  if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
    return false
  }

  // Return a object with the x and y coordinates of the intersection
  let x = x1 + ua * (x2 - x1)
  let y = y1 + ua * (y2 - y1)

  return { x: Math.floor(x), y: Math.floor(y) }
}
